import { createRouter, createWebHistory } from 'vue-router'
import AuthService from '@/services/auth.service'
import { hasAnyPermission, modulePermissions, hasSettingsAccess } from '@/utils/permissions-check'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/auth/LoginView.vue'),
    meta: { requiresGuest: true },
  },
  {
    path: '/',
    component: () => import('@/layouts/DashboardLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/DashboardView.vue'),
      },
      {
        path: 'documents',
        name: 'Documents',
        component: () => import('@/views/documents/DocumentsView.vue'),
        meta: { module: 'documents' },
      },
      {
        path: 'boxes',
        name: 'Boxes',
        component: () => import('@/views/boxes/BoxesView.vue'),
        meta: { module: 'boxes' },
      },
      {
        path: 'users',
        name: 'Users',
        component: () => import('@/views/users/UsersView.vue'),
        meta: { module: 'users' },
      },
      {
        path: 'settings',
        name: 'Settings',
        component: () => import('@/views/settings/SettingsView.vue'),
        meta: { module: 'settings' },
      },
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/',
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

// Navigation guard
router.beforeEach((to, from, next) => {
  const isAuthenticated = AuthService.isAuthenticated()

  if (to.meta.requiresAuth && !isAuthenticated) {
    next({ name: 'Login' })
  } else if (to.meta.requiresGuest && isAuthenticated) {
    next({ name: 'Dashboard' })
  } else if (to.meta.module && isAuthenticated) {
    // Check module permissions
    const user = AuthService.getCurrentUser()
    const userPermissions = user?.permissions || []
    
    if (to.meta.module === 'settings') {
      // Settings requires any settings-related permission
      if (hasSettingsAccess(userPermissions)) {
        next()
      } else {
        next({ name: 'Dashboard' })
      }
    } else {
      // Other modules
      const permissions = modulePermissions[to.meta.module]
      if (permissions && hasAnyPermission(userPermissions, permissions)) {
        next()
      } else {
        next({ name: 'Dashboard' })
      }
    }
  } else {
    next()
  }
})

export default router
